import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchCollections = () => api.get("/collections").then((r) => r.data);
export const fetchProducts = (collection) =>
  api.get("/products", { params: collection ? { collection } : {} }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchReviews = () => api.get("/reviews").then((r) => r.data);
export const subscribe = (email) => api.post("/subscribe", { email }).then((r) => r.data);
export const createCheckout = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
